export const LIMOUSINE_SUPPLIER_IDS = ['okkbus', 'hanshin_bus'];

export const LIMOUSINE_TIMETABLE_URL =
  'https://www.hankyu-kankobus.co.jp/limousine/timetable/UM/';
